import DOMPurify from 'isomorphic-dompurify';

import { useConsentManager } from '#/lib/consent-manager';
import type { SanityIframeEmbed } from '#/lib/sanity/queries/iframeEmbed';

export function IframeEmbed({ iframeScript }: SanityIframeEmbed) {
  const sanitizedHtml = DOMPurify.sanitize(iframeScript, {
    ALLOWED_TAGS: ['iframe'],
    ALLOWED_ATTR: [
      'src',
      'width',
      'height',
      'allow',
      'allowfullscreen',
      'frameborder',
      'scrolling',
      'title',
      'name',
      'id',
      'class',
      'sandbox',
      'loading',
      'referrerpolicy',
      'srcdoc',
    ],
  });

  const { airgap } = useConsentManager();

  // Force Iframes to show in Vercel Preview environments
  const shouldShowIframe = airgap || process.env.VERCEL_ENV !== 'production';

  return (
    <>
      {shouldShowIframe && (
        <div
          className="my-50 m:my-60"
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
      )}
    </>
  );
}
